import { render, staticRenderFns } from "./DailyVerse.vue?vue&type=template&id=68bc54dc&"
import script from "./DailyVerse.vue?vue&type=script&lang=js&"
export * from "./DailyVerse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports